// Optional GA4 / Google Ads integration. Disabled until REACT_APP_GA4_ID
// (and optionally REACT_APP_GOOGLE_ADS_ID) are set in frontend/.env.
// Events: phone_cta_click, email_cta_click — separated by cta_location and page.
const GA4_ID = process.env.REACT_APP_GA4_ID;
const ADS_ID = process.env.REACT_APP_GOOGLE_ADS_ID;

let initialized = false;

export function initAnalytics() {
    if (initialized || !GA4_ID || typeof window === "undefined") return;
    initialized = true;
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
        window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    window.gtag("config", GA4_ID);
    if (ADS_ID) window.gtag("config", ADS_ID);
}

export function trackEvent(name, params = {}) {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
        window.gtag("event", name, params);
    }
}

export function trackPhoneClick(location) {
    trackEvent("phone_cta_click", {
        cta_location: location,
        page_path: window.location.pathname,
    });
}

export function trackEmailClick(location) {
    trackEvent("email_cta_click", {
        cta_location: location,
        page_path: window.location.pathname,
    });
}
